import { defineMessages } from 'react-intl'

export default defineMessages({
  addMemberpageTitle: {
    id: 'familymodal.addmemberpagetitle',
    defaultMessage: 'Add family member',
  },
  editMemberpageTitle: {
    id: 'familymodal.editmemberpagetitle',
    defaultMessage: 'Edit family member',
  },
  content: {
    id: 'familymodal.content',
    defaultMessage:
      'Please remember that for children under the age of 16 all consultations must be via video and a parent or guardian must be present.',
  },
  save: {
    id: 'familymodal.save',
    defaultMessage: 'Save',
  },
})
